import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidEmail } from '@domains';

/**
 * The one email rule, mirroring zod's `z.email()` in resupply-master. Reports the `email`
 * key deliberately — the same key Angular's built-in produces, so no template had to change.
 * Empty passes; requiredness is `Validators.required`'s job.
 */
export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value?.trim()) return null; // a space is "empty" everywhere else here (contactIsUsed trims)
    return isValidEmail(value) ? null : { email: true };
  };
}
